/**
 * LineChart: one or two series over ordered labels (days, weeks), optional area fill.
 * Props: see CartesianProps in CartesianChart.tsx, plus `area?: boolean` (fills under the first series only).
 * Example: <LineChart caption="Revenue" labels={days} series={[{ key: 'rev', label: 'Revenue', values }]} formatValue={money} area />
 */
import { CartesianChart, CartesianProps } from './CartesianChart';

export type LineChartProps = CartesianProps & { area?: boolean };

export const LineChart = (props: LineChartProps) => <CartesianChart kind="line" {...props} />;
